import { useTranslation } from 'react-i18next';

import { registerPackageResources } from '@inbody/core';

import en from './en.json';
import ko from './ko.json';

const namespace = 'keycloak';

declare module 'i18next' {
  interface I18nNamespaces {
    [namespace]: typeof ko;
  }
}

export const useKeycloakText = () => {
  const { t } = useTranslation('keycloak');
  return { t };
};

// i18n 리소스
export const keycloakResources = {
  ko: {
    [namespace]: ko,
  },
  en: {
    [namespace]: en,
  },
};

registerPackageResources({
  namespace: namespace,
  resources: keycloakResources,
});
